<template>
  <latest-posts v-if="show === 'latest-posts'" />
</template>
<script>
  import LatestPosts from '../components/LatestPosts.vue'
  import Mixins from '../helpers/Mixins'

  export default {
    name: 'HomePage',
    components: {
      LatestPosts
    },
    mixins: [
      Mixins
    ],
    data () {
      return {
        show: this.$store.state.homePageContents
      }
    },
    mounted () {
      const showOnHomePage = this.$store.state.homePageContents
      if (showOnHomePage !== 'latest-posts' && showOnHomePage.includes('redirect:')) {
        // "homePageContents": "redirect:page-slug",
        const page = showOnHomePage.split(':')[1]
        this.$router.push({
          path: `${this.$store.state.pageTopSlug}/${page}`
        })
      } else {
        // "homePageContents": "latest-posts",
        this.show = showOnHomePage
        this.setTitle()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/HomePage.vue